<template>
    <div class="mobile-filters">
        <FilterInputs class="mobile-filters__selects" ref="filterPanelSelects">
            <MobileClearFilters />
        </FilterInputs>
    </div>
</template>

<script>
    import FilterInputs from 'components/user/organizationreport/filters/FilterInputs'
    import MobileClearFilters from 'components/searchable-listing/filters-elements/MobileClearFilters'
    export default {
        name: 'MobileFilters',
        components: { FilterInputs, MobileClearFilters },
    }
</script>

<style scoped lang="scss">
    .mobile-filters {
        &__selects {
            display: flex;
            flex-direction: row;
            flex: 1;
            flex-wrap: wrap;
            justify-content: flex-start;
        }
    }
</style>
